import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "../../components/Carousel";
import TestimonialCard from "./TestimonialCard";

const TestimonialCarousel = () => {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 7000,
    dots: true,
    speed: 500,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          centerPadding: "0",
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
    ],
  };

  return (
    <Carousel settings={settings}>
      <TestimonialCard
        university="University College London"
        studentName="이 O O 학생"
        achievement="2020년 합격"
        description="현재 AS를 끝내고 A2를 시작하려고 하는 학생들이나, 방학 기간에 A2를
              한국에서 혼자 공부하고 있는 학생들, 혼자 공부하는데 성적이
              정체되어있어 고민인 학생들에게 특히 오버더문에듀를 추천합니다.
              더욱이 단기간에 성적 향상을 이루어 내야 하는 학생들은 명문대
              강사님들이 경험을 바탕으로 가르쳐주시는 Exam Technique을 습득하여
              큰 성적 향상을 이룰 수 있을 거라 확신합니다."
        course="생명의료과학과"
        imgLogo="uni_logo_ucl.png"
      />
      <TestimonialCard
        university="London School of Economics"
        studentName="박 O O 학생"
        achievement="2020년 합격"
        description="현재 AS를 끝내고 A2를 시작하려고 하는 학생들이나, 방학 기간에 A2를
              한국에서 혼자 공부하고 있는 학생들, 혼자 공부하는데 성적이
              정체되어있어 고민인 학생들에게 특히 오버더문에듀를 추천합니다.
              더욱이 단기간에 성적 향상을 이루어 내야 하는 학생들은 명문대
              강사님들이 경험을 바탕으로 가르쳐주시는 Exam Technique을 습득하여
              큰 성적 향상을 이룰 수 있을 거라 확신합니다."
        course="경영학과"
        imgLogo="uni_logo_lse.png"
      />
      <TestimonialCard
        university="University College London"
        studentName="문 O O 학생"
        achievement="2019년 합격"
        description="현재 AS를 끝내고 A2를 시작하려고 하는 학생들이나, 방학 기간에 A2를
              한국에서 혼자 공부하고 있는 학생들, 혼자 공부하는데 성적이
              정체되어있어 고민인 학생들에게 특히 오버더문에듀를 추천합니다.
              더욱이 단기간에 성적 향상을 이루어 내야 하는 학생들은 명문대
              강사님들이 경험을 바탕으로 가르쳐주시는 Exam Technique을 습득하여
              큰 성적 향상을 이룰 수 있을 거라 확신합니다."
        course="컴퓨터공학과"
        imgLogo="uni_logo_ucl.png"
      />
      <TestimonialCard
        university="London School of Economics"
        studentName="서 O O 학생"
        achievement="2019년 합격"
        description="현재 AS를 끝내고 A2를 시작하려고 하는 학생들이나, 방학 기간에 A2를
              한국에서 혼자 공부하고 있는 학생들, 혼자 공부하는데 성적이
              정체되어있어 고민인 학생들에게 특히 오버더문에듀를 추천합니다.
              더욱이 단기간에 성적 향상을 이루어 내야 하는 학생들은 명문대
              강사님들이 경험을 바탕으로 가르쳐주시는 Exam Technique을 습득하여
              큰 성적 향상을 이룰 수 있을 거라 확신합니다."
        course="정치외교학과"
        imgLogo="uni_logo_lse.png"
      />
      <TestimonialCard
        university="Imperial College London"
        studentName="김 O O 학생"
        achievement="2019년 합격"
        description="현재 AS를 끝내고 A2를 시작하려고 하는 학생들이나, 방학 기간에 A2를
              한국에서 혼자 공부하고 있는 학생들, 혼자 공부하는데 성적이
              정체되어있어 고민인 학생들에게 특히 오버더문에듀를 추천합니다.
              더욱이 단기간에 성적 향상을 이루어 내야 하는 학생들은 명문대
              강사님들이 경험을 바탕으로 가르쳐주시는 Exam Technique을 습득하여
              큰 성적 향상을 이룰 수 있을 거라 확신합니다."
        course="기계공학과"
        imgLogo="uni_logo_imperial.png"
      />
    </Carousel>
  );
};

export default TestimonialCarousel;
